export default __webpack_public_path__ + "media/icons/quote-tick-28f3c44f.svg";